// Gemeinsame Chart-Analyse-Helfer (EMA, Support/Widerstand) fuer
// MarketdataChartTile.js - dieselbe Logik wie in MarketdataDetailPanel.js,
// hier ausgelagert, damit die kleinen Chart-Kacheln im Charts-Modul
// (MarketdataCharts.js) dieselben Indikatoren zeigen koennen, ohne den Code
// zu duplizieren.

// Exponentiell gleitender Durchschnitt ueber "period" Perioden - haengt pro
// Kerze ein Feld "ema<period>" an (null, solange nicht genug Kerzen fuer eine
// halbwegs eingeschwungene Berechnung vorliegen).
export function computeEma(chartData, period) {
	const key = 'ema' + period;
	if (!chartData || chartData.length === 0) {
		return { data: chartData || [], hasValues: false };
	}
	const alpha = 2 / (period + 1);
	let ema = null;
	let seededCount = 0;
	const data = chartData.map((row) => {
		if (row.close == null) {
			return { ...row, [key]: ema };
		}
		ema = ema == null ? row.close : row.close * alpha + ema * (1 - alpha);
		seededCount++;
		return { ...row, [key]: seededCount >= period ? ema : null };
	});
	return { data, hasValues: data.some((row) => row[key] != null) };
}

// Einfache Pivot-Erkennung (lokale Hoch-/Tiefpunkte, inkl. Support/
// Resistance-Flip) - siehe MarketdataDetailPanel.js fuer die ausfuehrliche
// Begruendung/Historie. Liefert bis zu levelCount Unterstuetzungen/
// Widerstaende, naechste zuerst, mindestens ein Stueck auseinander.
export function computeSupportResistance(chartData, currentPrice, levelCount = 3) {
	const window = 3;
	if (!chartData || chartData.length < window * 2 + 1 || currentPrice == null) {
		return { supports: [], resistances: [] };
	}
	const pivotLows = [];
	const pivotHighs = [];
	for (let i = window; i < chartData.length - window; i++) {
		const value = chartData[i].close;
		if (value == null) continue;
		const slice = chartData.slice(i - window, i + window + 1);
		if (slice.every((d) => d.close == null || d.close >= value)) pivotLows.push(value);
		if (slice.every((d) => d.close == null || d.close <= value)) pivotHighs.push(value);
	}
	const flippedSupports = pivotHighs.filter((v) => v < currentPrice);
	const flippedResistances = pivotLows.filter((v) => v > currentPrice);

	const uniqueSupports = [...new Set([...pivotLows, ...flippedSupports].filter((v) => v < currentPrice))].sort((a, b) => b - a);
	const uniqueResistances = [...new Set([...pivotHighs, ...flippedResistances].filter((v) => v > currentPrice))].sort((a, b) => a - b);

	const MIN_GAP_RATIO = 0.015;
	const MIN_DISPLAY_GAP = 0.01;
	const minGap = Math.max(currentPrice * MIN_GAP_RATIO, MIN_DISPLAY_GAP);
	function pickDistinctLevels(sortedCandidates) {
		const accepted = [];
		for (const candidate of sortedCandidates) {
			if (accepted.every((level) => Math.abs(level - candidate) >= minGap)) {
				accepted.push(candidate);
				if (accepted.length >= levelCount) break;
			}
		}
		return accepted;
	}

	return {
		supports: pickDistinctLevels(uniqueSupports),
		resistances: pickDistinctLevels(uniqueResistances),
	};
}
